import React from 'react';

import PropTypes from 'prop-types';

import { localize } from 'wanderu-i18n';

import {
    ColumnMenu,
    ColumnMenuItem,
} from '../../MenuTypes';
import {
    getSymbolForLocale,
} from '../../utils/currency';
import Events from '../events/CurrencyEvents';

import styles from './MultiColumnMenu.scss';

function MultiColumnMenu(props) {
    const {
        currentCurrency,
        currentLocale,
        onComplete = () => undefined,
        onCurrencyChange = () => undefined,
        supportedCurrencies,
        t,
    } = props;

    const onItemClick = (currency) => {
        onCurrencyChange(currency);
        onComplete();
        Events.clicked({
            action: 'select',
            navType: 'nav_bar',
            selectedCurrency: currency,
            unselectedCurrency: currentCurrency,
        });
    };

    return (
        <ColumnMenu
            columns={3}
        >
            {supportedCurrencies.map((supportedCurrency) => {
                return (
                    <ColumnMenuItem
                        className={styles.currencyContainer}
                        key={supportedCurrency}
                        onItemClick={() => onItemClick(supportedCurrency)}
                    >
                        <span
                            className={styles.currencyLink}
                            role="button"
                        >
                            <div className={styles.currency}>
                                {getSymbolForLocale(currentLocale, supportedCurrency)}
                            </div>
                            {t(`${supportedCurrency.toLowerCase()}-currency`)}
                        </span>
                    </ColumnMenuItem>
                );
            })}
        </ColumnMenu>
    );
}

MultiColumnMenu.propTypes = {
    currentCurrency: PropTypes.string.isRequired,
    currentLocale: PropTypes.string.isRequired,
    onComplete: PropTypes.func,
    onCurrencyChange: PropTypes.func,
    supportedCurrencies: PropTypes.arrayOf(PropTypes.string).isRequired,
    t: PropTypes.func.isRequired,
};

export { MultiColumnMenu };
export default localize(MultiColumnMenu, ['t'], 'baseApp');
